import OpenSeadragon from 'openseadragon';
import { size } from 'lodash';

export function initOSD(viewerRef, source, sourceType) {
  if (!source) return null;

  const imageUrl = source.stream_url || source.plan_image;
  const hasTiles = size(source.tiles);
  const useImageSource =
    sourceType == 'image' || source.tiles_available === false || !hasTiles;

  if (useImageSource && !imageUrl) {
    return null;
  }

  const viewer = OpenSeadragon({
    element: viewerRef.current,
    tileSources: useImageSource
      ? {
          type: 'image',
          url: imageUrl,
          //buildPyramid: false,
          width: source.width,
          height: source.height,
        }
      : {
          height: source.height,
          width: source.width,
          tileSize: 256,
          getTileUrl: (level, x, y) => source.tiles?.[`${level}-${x}-${y}`],
        },
    showNavigationControl: false,
    defaultZoomLevel: 0,
    minZoomLevel: 0,
    maxZoomLevel: 14,
    visibilityRatio: 0.98,
    animationTime: 1.2,
    constrainDuringPan: true,
    gestureSettingsMouse: { clickToZoom: false },
    gestureSettingsTouch: {
      clickToZoom: false,
      flickEnabled: true,
      pinchToZoom: true,
      scrollToZoom: true,
    },
  });

  viewer.drawer.canvas.style.background = useImageSource
    ? 'transparent'
    : '#f2f2f0';

  return viewer;
}
